import { Component, ElementRef,ViewChild, QueryList, ViewChildren, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoService,TranslocoPipe } from '@jsverse/transloco';
import { ConsentDialogComponent } from '../consent-dialog/consent-dialog.component';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { OtpChangePasswordDialogComponent } from '../otp-changePassword/otpchangepwd-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { NavigationFlowService } from 'app/services/navigation-flow.service';

@Component({
  selector: 'app-otpsuggest-dialog',
  templateUrl: './otpsuggestpwd-dialog.component.html',
  imports: [
    FormsModule,
    CommonModule,
    TranslocoPipe,
    MatIconModule
  ],
})
export class OtpSuggestDialogComponent {
  buttonDisabled: boolean = true;
  apiResponse: any;
  email: string;
  constructor(
        private _dialogRef: MatDialogRef<any>,
        private _dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private translocoService: TranslocoService,
        private dialogUtilsService: DialogUtilsService,
        private navigationFlow: NavigationFlowService,
      ) {}

  ngOnInit(): void {
    if (this.data) {
      this.apiResponse = this.data.apiResponse;
      this.email = this.data.email;
      
    }
  }
  cambiarContrasenya(){

    if (this._dialogRef) {
      // Close without animation
      this._dialogRef.close();
    }
  
    const { width, height } = this.dialogUtilsService.calculateDialogSize();
  
    this._dialogRef = this._dialog.open(OtpChangePasswordDialogComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      // Disable enter animation
      enterAnimationDuration: '0ms',
      // Disable exit animation
      exitAnimationDuration: '0ms',
      data: {
        apiResponse: this.apiResponse,
        email: this.email
      }
    });
  
    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);
  
    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });

  }
  
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  /**
   * Close button handler - Continue after successful OTP
   * This handles the success flow: close dialog and navigate/notify parent
   */
  close(): void {
    console.log('[OTP-SUGGEST] Continue button clicked - closing with success');
    
    const isInIframe = this.isRunningInIframe();
    const redirectUrl = this.apiResponse?.returnUrl;
    
    if (isInIframe) {
      // In iframe mode: send loginSuccess message to parent
      console.log('[OTP-SUGGEST] In iframe - sending loginSuccess message');
      
      if (window.parent && window.parent !== window) {
        const loginSuccessMessage = {
          type: 'loginSuccess',
          userData: {
            email: this.email,
            redirectUrl: redirectUrl
          }
        };
        
        console.log('[OTP-SUGGEST] Sending message:', loginSuccessMessage);
        window.parent.postMessage(loginSuccessMessage, '*');
      }
    } else {
      // In standalone mode: navigate to returnUrl
      console.log('[OTP-SUGGEST] In standalone - navigating to:', redirectUrl);
      
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
    
    // Close the dialog
    this._dialogRef.close("response");
  }

  /**
   * Method for X button close - different from Continue button
   * Uses dialogUtilsService to handle both v1.5 and v2.0 modes
   */
  closeDialog(): void {
    console.log('[OTP-SUGGEST] closeDialog called (X button), calling dialogUtilsService');
    this.dialogUtilsService.closeDialog(this._dialogRef);
    console.log('[OTP-SUGGEST] dialogUtilsService.closeDialog completed');
  }

  private isRunningInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we get a security error, we're definitely in an iframe
      return true;
    }
  }

  shouldShowCloseButton(): boolean {
    return true;
    return this.dialogUtilsService.shouldShowCloseButton();
  }
}
